import { PlaceHolderImage } from '@/shared/assets'
import { Suspense } from 'react'
import { useInView } from 'react-intersection-observer'
// import { useDebouncedCallback } from 'use-debounce';
import { useTmeInfoQuery } from '@/true-fsd/data/telegram'
import React from 'react'

interface UserIconProps {
    username: string
    className?: string
    photoUrl?: string | null
}

const ALT = 'User Icon'

export const UserIcon = React.memo(
    ({ username, className, photoUrl }: UserIconProps) => {
        if (photoUrl) {
            return <img src={photoUrl} alt={ALT} className={className} />
        }

        return (
            <Suspense
                fallback={
                    <img
                        src={PlaceHolderImage}
                        className={className}
                        alt="Loading..."
                    />
                }
            >
                <QueryUserIcon username={username} className={className} />
            </Suspense>
        )
    }
)

const QueryUserIcon = React.memo(({ username, className }: UserIconProps) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '500px', // Load icons when they are 200px away from the viewport
    })

    const { data } = useTmeInfoQuery(
        { username },
        {
            enabled: inView,
        }
    )

    return (
        <img
            ref={ref}
            src={data?.smallPhoto ?? PlaceHolderImage}
            alt={ALT}
            className={className}
        />
    )
})
